import shieldIcon from "@loot-os/icons/icons/shield";
import { Icon } from "../core/Icon.js";
import { cn } from "../foundations/cn.js";
import { RARITY_TEXT, type RarityTier } from "./rarity.js";

export interface LevelBadgeProps {
  /** The player's level band, drawn in its tier's color. */
  tier: RarityTier;
  /** What a screen reader hears, e.g. "Level 12". */
  label: string;
  className?: string;
}

/** A player's level as a small filled shield beside their name. The label is read, not shown. */
export function LevelBadge({ tier, label, className }: LevelBadgeProps) {
  return (
    <span className={cn("inline-flex shrink-0 items-center", RARITY_TEXT[tier], className)}>
      <Icon icon={shieldIcon} size={14} className="fill-current" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
